import { render, staticRenderFns } from "./ChartFaturamentoMes.vue?vue&type=template&id=247d1e52"
import script from "./ChartFaturamentoMes.vue?vue&type=script&lang=js"
export * from "./ChartFaturamentoMes.vue?vue&type=script&lang=js"
import style0 from "./ChartFaturamentoMes.vue?vue&type=style&index=0&id=247d1e52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports